// extracted by mini-css-extract-plugin
export var buttons = "_4e-0";
export var buttonsActive = "_4e-h";
export var cancelConfirm = "_4e-1";
export var closeButton = "_4e-2";
export var column = "_4e-3";
export var container = "_4e-4";
export var detailHeader = "_4e-6";
export var detailTitle = "_4e-7";
export var detailsContent = "_4e-5";
export var header = "_4e-8";
export var headerWithClose = "_4e-9";
export var icon = "_4e-a";
export var infoIcon = "_4e-c";
export var informationContainer = "_4e-b";
export var sideDrawer = "_4e-d";
export var sideDrawerOpen = "_4e-e";
export var stickyFooter = "_4e-f";
export var typeOption = "_4e-g";